import { render, staticRenderFns } from "./ModalCompleteShipment.vue?vue&type=template&id=59977ddc&lang=pug&"
import script from "./ModalCompleteShipment.vue?vue&type=script&lang=js&"
export * from "./ModalCompleteShipment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports